window.knarrConfig = {
  routesJsonFile: 'json!config/route/' + $('#routesJSON').data('routesjson') + '.json',
  i18nJsonFile: 'json!config/locale/' + $('#i18nJSON').data('i18njson') + '.json'
};

define('config-service',[window.knarrConfig.routesJsonFile, window.knarrConfig.i18nJsonFile, 'jquery-deparam'], function(routesJson, i18nJson) {

  var app = angular.module('config.service', []);

  app.provider('config', [function() {

    angular.extend(this, $.deparam(decodeURIComponent($('#config').data('config'))));

    this.i18n = i18nJson;
    this.routes = routesJson;

    this.$get = [function configFactory() {
      return this;
    }];

  }]);

  return app;

});

